/**
 * @author bgr
 */

const states = new WeakMap();
const updating = new WeakMap();

function definer(prop) {
	return {
		enumerable: true,
		get() {
			return states.get(this)[prop];
		},
		set(value) {
			const oldValue = states.get(this)[prop];
			states.set(this, Object.assign(states.get(this), { [prop]: value }));
			if (this.propertyChangedCallback) {
				this.propertyChangedCallback(prop, oldValue, value);
			}
			this.update();
		},
	};
}

function isConnected(node) {
	if ("isConnected" in window.Node.prototype) {
		return node.isConnected;
	}
	return document.body.contains(node);
}

export const removeInitialContent = BaseClass =>
	class extends BaseClass {
		constructor() {
			super();
			this.innerHTML = "";
		}
	};

export function stateful(BaseClass) {
	const StatefulClass = class extends BaseClass {
		constructor() {
			super();
			states.set(this, BaseClass.getInitialState());
		}

		async update() {
			if (updating.get(this)) {
				return;
			}
			updating.set(this, true);
			await Promise.resolve();
			updating.delete(this);
			if (isConnected(this)) {
				this.render();
			}
		}

		async connectedCallback() {
			if (typeof super.connectedCallback === "function") {
				await super.connectedCallback();
			}
			this.update();
		}
	};

	const definition = {};
	for (var prop in BaseClass.getInitialState()) {
		definition[prop] = definer(prop);
	}
	Object.defineProperties(StatefulClass.prototype, definition);

	return StatefulClass;
}
